import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";

const RazorpayList = () => {
    let today_date = (new Date()).toISOString().split('T')[0];
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [formData, setFormData] = useState({
        order_date: "",
        status: "",
        order: ""
    });
    const [orderStatuses, setOrderStatuses] = useState([
        { label: "--select--", value: "" },
        { label: "PENDING", value: "PENDING" },
        { label: "SUCCESS", value: "SUCCESS" },
        { label: "FAILURE", value: "FAILURE" }
    ]);
    const [storeOptions, setStoreOptions] = useState([]);
    const [Data, SetData] = useState([]);
    let navigate = useNavigate();

    const GetData = async () => {
        setLoading(true);
        try {
            const query = new URLSearchParams();

            if (formData.status) {
                query.append("status", formData.status);
            }
            if (formData.order) {
                query.append("order", formData.order);
            }
            if (formData.order_date) {
                query.append("order_date", formData.order_date);
            }

            query.append("page", currentPage);
            query.append("page_size", RowPerPage);

            const response = await axiosConfig.get(`/accounts/razorpay-payments/?${query.toString()}`);
            SetData(response.data.results);
            setTotalRows(response.data.count);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchStore = async () => {
        try {
            const response = await axiosConfig.get(`/accounts/orders/?page_size=1000`);
            setStoreOptions([{ id: '', name: '---Select Order---' }, ...response.data.results]);
        } catch (error) {
            console.error(error);
        }
    };

    function formatDate(inputDate) {
        if (!inputDate) return '';
        const date = new Date(inputDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true
        },
        {
            name: "Payment Id",
            selector: "payment_id",
            cell: row => row.payment_id,
            sortable: true
        },
        {
            name: "Profile Name",
            selector: "profile",
            cell: row => row.order?.profile?.hcc_id,
            sortable: true
        },
        {
            name: "Total Amount",
            selector: "order_amount",
            cell: row => row.order_amount,
            sortable: true
        },
        {
            name: "Plan",
            selector: "plan",
            cell: row => row.order?.plan?.name,
            sortable: true
        },
        {
            name: "Order Id",
            selector: "order",
            cell: row => row.order?.id,
            sortable: true
        },
        {
            name: "Payment Date",
            selector: "order_date",
            cell: row => row?.order_date,
            sortable: true
        },
        {
            name: "Payment status",
            selector: "status",
            cell: row => row.status,
            sortable: true
        }
    ]
    const handleChange = (selectedOption, actionMeta) => {
        console.log(selectedOption, actionMeta)
        const { name } = actionMeta;
        const value = selectedOption ? selectedOption.value : "";
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };
    const handleSubmit = () => {
        GetData();
    };

    const multiSelectStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#c9dddc' : 'white',
            color: state.isSelected ? '#1b7d78' : 'black',
            ':hover': {
                backgroundColor: '#c9dddc',
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#c9dddc',
            color: '#1b7d78',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#1b7d78',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#1b7d78',
            ':hover': {
                backgroundColor: '#1b7d78',
                color: 'white',
            },
        }),
    };

    useEffect(() => {
        GetData();
        fetchStore();
    }, [currentPage, RowPerPage]);

    return (
        <>
            
                <div className="child-sidenav">
                    <div className="childnav-content reports-parent">
                        <div className="report-filters">
                            <Select
                                className="flex-1"
                                options={orderStatuses}
                                name="status"
                                onChange={handleChange}
                                styles={multiSelectStyles}
                                placeholder="Status"
                            />
                            <div className="form-group flex-1">
                                <input
                                    className="form-control"
                                    type="date"
                                    name="order_date"
                                    value={formData.order_date}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <Select
                                placeholder="Order"
                                className="flex-1"
                                name="order"
                                options={storeOptions.map((res) => (
                                    { "value": res.id, "label": res.id }
                                ))}
                                value={storeOptions.map(res => ({ "value": res.id, "label": res.id })).find(res => res.value === formData.id)}
                                onChange={handleChange}
                                styles={multiSelectStyles}
                            />
                            <button className="btn btn-primary" style={{ height: '37px' }} onClick={handleSubmit}>Get Reports</button>
                        </div>
                        <div className="table-responsive marginTop">
                            <DataTable
                                columns={columns}
                                data={Data}
                                pagination
                                paginationTotalRows={totalRows}
                                paginationPerPage={RowPerPage}
                                paginationDefaultPage={currentPage}
                                onChangePage={(page) => setCurrentPage(page)}
                                paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                                paginationServer
                                fixedHeader
                                subHeader
                                customStyles={tableCustomStyles}
                                progressPending={loading}
                                progressComponent={<div className="loader-container">
                                    <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                                </div>}
                            />
                        </div>
                    </div>
                </div>
                {/* {popupType !== "" &&
                    <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation={`/dashboard/masters/razorpay-payments/${AudiId}/edit`} />
                }
                {deletePopupType !== "" &&
                    <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
                } */}
            
        </>
    );
};

export { RazorpayList };
